import React from 'react';
import styled from 'styled-components';
import { BloxButton } from 'styled_components/Common/BloxButton';

const ConfigBodyStyle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow-wrap: break-word;
	.key {
		margin-top: 20px;
		margin-bottom: 20px;
		max-width: 250px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.key {
			margin-top: 40px;
			margin-bottom: 40px;
			max-width: 400px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.key {
			margin-top: 60px;
			margin-bottom: 60px;
			max-width: 600px;
		}
	}
`;
function copyText(value) {
	navigator.clipboard.writeText(value);
}

export const CredentialModalBody = ({ security }) => {
	return (
		<ConfigBodyStyle>
			<div className='key body10'>{security?.secret_key}</div>
			<BloxButton
				className='buttons41'
				id='copy-button'
				text='COPY'
				module='storage'
				enabled={true}
				onClick={() => copyText(security?.secret_key)}
				cypressId='okay'
			/>
		</ConfigBodyStyle>
	);
};
